const translations = {
    downloadAs: 'Download'
};

export default translations;
